import React from 'react';
import { DataGrid, Popup } from 'devextreme-react';
import {
    Paging,
    Pager,
    FilterRow,
    HeaderFilter,
    ColumnChooser,
    Column,
    Lookup,
    Editing,
    Button as ButtonGrid,
    Export
} from 'devextreme-react/data-grid';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { formatDate, formatDateTime } from '../../data/app';
import { cellRender, dataFormatId, dataFormatIdNotZero } from '../../utils/common';
import { preBillType } from '../../data/enums';

const PreventasPending = () => {

    const onRowPrepared = (e) => {
        if (e.rowType == 'data') {
            if (!e.data.active)
                e.rowElement.classList.add('no-activo');
            else {
                if (e.data.preBillTypeId == preBillType.facturacion)
                    e.rowElement.classList.add('converted');

            }

        }
    }

    const onCellPrepared = e => {

        const cellsQuantity = ['payoff']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                if (e.row.data.payoff)
                    e.cellElement.classList.add('pagada');
                else
                    e.cellElement.classList.add('pendiente');

            if (e.column.dataField == 'id')
                e.cellElement.classList.add('col-id-factura');
            if (e.column.dataField == 'reference')
                e.cellElement.classList.add('col-reference-factura');
        }

    }

    let extraParameter = [['preBillTypeId', 2]];

    return (
        <div>
            <h3>Pendientes de entrega</h3>
            <DataGrid id="gridContainer"
                selection={{ mode: 'single' }}
                dataSource={store({ uri: uri.prebills, remoteOperations: true, extraParameter })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                onRowPrepared={onRowPrepared}
                onCellPrepared={onCellPrepared}
                remoteOperations={{
                    paging: true,
                    filtering: true
                }}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showInfo={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
              
                <Column dataField="id" caption="Id" width={80} cellRender={dataFormatId} />
                {/* <Column dataField="billId" caption="Factura" width={80} cellRender={dataFormatIdNotZero} /> */}
                <Column dataField="date" caption="Fecha" dataType='date' format={formatDate} width={110} />
                <Column dataField="nombre" caption="Cliente" minWidth={200}  allowHeaderFiltering={false} />
              
                <Column dataField="initialValue" caption="Valor Inicial" width={100} cellRender={cellRender()} />
                <Column dataField="total" width={100} cellRender={cellRender()} />
                <Column dataField="deliveryDate" caption='Fecha de Entrega' dataType='date' width={160} format={formatDate}/>
                {/* <Column dataField="isDeliveriede" width={100} caption="Entregado" cellRender={cellRenderDelivery} /> */}
                <Column dataField="createAt" caption='Creado el' dataType='date' format={formatDate} width={180} visible={false} />
                <Editing
                    mode="popup"
                    allowDeleting={false}
                    allowUpdating={false}
                    useIcons={false}
                ></Editing>
            </DataGrid>
        </div>
    );
}

export default PreventasPending;
